import { render, staticRenderFns } from "./ChemUBC_SB_Quiz1_1.vue?vue&type=template&id=cd875384&"
import script from "./ChemUBC_SB_Quiz1_1.vue?vue&type=script&lang=js&"
export * from "./ChemUBC_SB_Quiz1_1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VFileInput,VForm,VRadio,VRadioGroup})
